import React from 'react';
import Icon from '../ui/Icon';

const statusConfig = {
  offer_made: { label: 'Offer Made', className: 'badge-blue', step: 1 },
  under_contract: { label: 'Under Contract', className: 'badge-purple', step: 2 },
  inspection: { label: 'Inspection', className: 'badge-amber', step: 3 },
  appraisal: { label: 'Appraisal', className: 'badge-orange', step: 4 },
  closing: { label: 'Closing', className: 'badge-cyan', step: 5 },
  closed: { label: 'Closed', className: 'badge-emerald', step: 6 },
  cancelled: { label: 'Cancelled', className: 'badge-red', step: 0 }
};

function formatDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function TransactionCard({ transaction, listing, agent, onEdit }) {
  const status = statusConfig[transaction.status] || statusConfig.offer_made;
  const progress = status.step > 0 ? (status.step / 6) * 100 : 0;

  return (
    <div className="card">
      <div className="p-5">
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="font-semibold text-slate-900">
              {listing?.title || 'Unknown Property'}
            </h3>
            <p className="text-sm text-slate-500">
              {listing?.address}, {listing?.city}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className={`badge ${status.className}`}>{status.label}</span>
            <button className="btn btn-ghost btn-icon" onClick={() => onEdit?.(transaction)}>
              <Icon name="edit" size={16} />
            </button>
          </div>
        </div>

        {status.step > 0 && (
          <div className="mb-4">
            <div className="progress-bar">
              <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
            </div>
            <div className="flex justify-between mt-1 text-xs text-slate-400">
              <span>Offer</span>
              <span>Closed</span>
            </div>
          </div>
        )}

        <div className="grid grid-2 gap-4 mb-4">
          <div className="flex items-center gap-2 text-sm">
            <Icon name="user" size={16} style={{ color: 'var(--slate-400)' }} />
            <div>
              <p className="text-xs text-slate-500">Buyer</p>
              <p className="font-medium text-slate-900">{transaction.buyer_name}</p>
            </div>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Icon name="user" size={16} style={{ color: 'var(--slate-400)' }} />
            <div>
              <p className="text-xs text-slate-500">Agent</p>
              <p className="font-medium text-slate-900">{agent?.full_name || 'Unassigned'}</p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between" style={{ paddingTop: '1rem', borderTop: '1px solid var(--slate-100)' }}>
          <div className="flex items-center gap-4">
            <div>
              <p className="text-xs text-slate-500">Offer</p>
              <p className="font-semibold text-slate-900">
                ${transaction.offer_price?.toLocaleString()}
              </p>
            </div>
            {transaction.final_price && (
              <>
                <Icon name="arrowRight" size={16} style={{ color: 'var(--slate-300)' }} />
                <div>
                  <p className="text-xs text-slate-500">Final</p>
                  <p className="font-semibold text-emerald-600">
                    ${transaction.final_price.toLocaleString()}
                  </p>
                </div>
              </>
            )}
          </div>
          {transaction.closing_date && (
            <div className="flex items-center gap-2 text-sm text-slate-500">
              <Icon name="calendar" size={16} />
              {formatDate(transaction.closing_date)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}